<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="400px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="280px">
               <v-row no-gutters>
                  <v-col cols="12">
                     <v-toolbar
                        flat
                        dense
                        :class="$globalstore.toolbar_headerclass"
                     >
                        <v-toolbar-title>
                           {{ formmode }}
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              Holiday
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2"
                           >Cancel</v-btn
                        >
                        <v-btn @click.native="OkBtnClick" class="mx-2"
                           >OK</v-btn
                        >
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-form ref="holidayform" v-model="formvalid">
                  <v-row no-gutters>
                     <v-col cols="12" md="12" class="px-5">
                        <v-text-field
                           label="Holiday Description"
                           v-model="edit_holiday_description"
                           required
                           :rules="[(v) => !!v || 'Description is required']"
                        >
                        </v-text-field>
                     </v-col>
                     <v-col cols="6" md="6" class="px-5">
                        <datepicker-dialog
                           labelname="Start Holiday Date"
                           :indate.sync="edit_start_holiday_date"
                           @return-date="onStartHolidayDateChange"
                        >
                        </datepicker-dialog>
                     </v-col>
                     <v-col cols="6" md="6" class="px-5">
                        <datepicker-dialog
                           labelname="End Holiday Date"
                           :indate.sync="edit_end_holiday_date"
                           @return-date="onEndHolidayDateChange"
                           :datereadonly="formmode == 'Edit'"
                        >
                        </datepicker-dialog>
                     </v-col>
                  </v-row>
               </v-form>
            </v-sheet>
         </v-dialog>
      </v-container>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import DatepickerDialog from "./DatepickerDialog.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         ConfirmDlg,
         DatepickerDialog,
      },

      data() {
         return {
            modal: false,
            formvalid: true,
            holiday_id: "",
            edit_holiday_description: "",
            edit_start_holiday_date: "",
            edit_end_holiday_date: "",
            edit_holiday_date: "",
            formmode: "Add",
         };
      },
      methods: {
         todayDate() {
            return this.$globalstore.currentDateISOString().substr(0, 10);
         },

         open() {
            this.formmode = "Add";
            this.holiday_id = "";
            this.edit_holiday_description = "";
            this.edit_start_holiday_date = this.todayDate();
            this.edit_end_holiday_date = this.edit_start_holiday_date;
            this.formvalid = true;

            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         edit(holidaydata) {
            this.formmode = "Edit";
            this.holiday_id = holidaydata.id;
            this.edit_holiday_description = holidaydata.holiday_description;
            this.edit_start_holiday_date = holidaydata.holiday_date;
            this.edit_end_holiday_date = holidaydata.holiday_date;
            this.formvalid = true;
            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         onStartHolidayDateChange(date) {
            this.edit_start_holiday_date = date;
            this.edit_end_holiday_date = date;
         },

         onEndHolidayDateChange(date) {
            this.edit_end_holiday_date = date;
         },

         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         OkBtnClick() {
            if (this.$refs.holidayform.validate()) {
               if (this.edit_end_holiday_date < this.edit_start_holiday_date) {
                  this.ShowMessage({
                     title: "Error",
                     message:
                        "End date must be equal or greater than start date.",
                     color: "red",
                  });
                  return;
               }

               let payload = {
                  holiday: {
                     id: this.holiday_id,
                     holidaydate: [
                        this.edit_start_holiday_date,
                        this.edit_end_holiday_date,
                     ],
                     holidaydescription: this.edit_holiday_description,
                  },
                  mode: this.formmode,
               };
               this.resolve(true);
               this.modal = false;
               this.$emit("input", payload);
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
            }
         },
      },
   };
</script>
